import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../Auth/AuthProvider";
import ResidentTrainingDetails from "../Training/Components/ResidentTrainingDetails";
import { abpnClient } from "../Services/AbpnClient";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import Autocomplete from "../Shared/Components/Autocomplete";
import HeaderWithTitle from "../Shared/Components/HeaderWithTitle";
import Resident from "../Residents/Models/Resident";
import { deepCopy } from "../Shared/Utility/DeepCopy";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MedicalEducation } from "../Residents/Models/MedicalEducation";
import ResidentInformation from "../Residents/Models/ResidentInformation";
import { ProfileContext } from "../Auth/ProfileProvider";
import { PreCertPaths } from "../Shared/Utility/PreCertLocationHelper";
import { AlumniRosterContext } from "../Contexts/AlumniRosterProvider";

export const AlumniResident = () => {
  const navigate = useNavigate();
  let { physicianId } = useParams();

  const { user } = useContext(ProfileContext);
  const { isRosterLoading, filteredRoster } = useContext(AlumniRosterContext);
  const [selectedResidentInfo, setSelectedResidentInfo] =
    useState<ResidentInformation>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [typeAheadResult, setTypeAheadResult] = useState<Resident>(null);

  const authContext = useContext(AuthContext);
  let programTypeId = user.trainingPrograms.find(
    (_) => _.trainingProgramId === user.selectedTrainingProgramId
  ).trainingProgramTypeId;
  let url = `/api/training/GetResident?programTypeId=${programTypeId}&physicianId=${physicianId}`;

  useEffect(() => {

    const getResident = async (physicianId: string) => {
      if(!parseInt(physicianId)){
        navigate(`/${PreCertPaths.NotFound}`)
        return;
      }

      setLoading(true);
      var resident = await abpnClient.get<Resident>(url, authContext);
      if (!resident) {
        navigate(`/${PreCertPaths.NotFound}`)
      }
      setSelectedResidentInfo(new ResidentInformation(resident, null));
      setLoading(false);
    };
    getResident(physicianId);
  }, [physicianId]);

  useEffect(() => {
    if (
      typeAheadResult === null ||
      typeAheadResult === selectedResidentInfo.resident
    )
      return;

    navigate(`/${typeAheadResult.physicianId}`)
    setSelectedResidentInfo(new ResidentInformation(typeAheadResult, null));
  }, [typeAheadResult]);
  
  const onReturnedToProgram = () => {
    navigate(`/`)
  }

  const updateResidentMedicalEducation = (
    medicalEducation: MedicalEducation
  ) => {
    let updated = deepCopy(selectedResidentInfo);
    updated.medicalEducation = medicalEducation;
    setSelectedResidentInfo(updated);
  };

  const typeAheadFilter = (f: string) => {
    return filteredRoster.filter((_) =>
      _.name?.fullName.toLowerCase().includes(f.toLowerCase())
    );
  };
  const getCurrentIndex = () => {
    return filteredRoster.findIndex(
      (_) => _.physicianId === selectedResidentInfo?.resident?.physicianId
    );
  };
  const getPreviousResident = () => {
    var index = getCurrentIndex();
    return filteredRoster[index - 1];
  };
  const getNextResident = () => {
    var index = getCurrentIndex();
    return filteredRoster[index + 1];
  };

  if (loading || isRosterLoading) return <AbpnSpinner />;

  return (
    <>
      <div className="d-flex justify-content-between">
        <HeaderWithTitle title={"Alumni Roster"} subTitle={""} />
        <div className="d-flex justify-content-end">
          <div className="d-flex flex-column">
            <div className="d-flex flex-row">
              <div className="mr-2">
                <Autocomplete
                  className="form-control form-control-sm ml-2"
                  width={"300px"}
                  selectedItem={null}
                  initialSelectedItem={""}
                  itemKey={(item: any) => item.id}
                  required={true}
                  itemToString={(item: any) => item?.name?.fullName}
                  filter={(f: string) => typeAheadFilter(f)}
                  maxItems={50}
                  items={filteredRoster}
                  matchKeys={["fullName"]}
                  placeholder={"Search Alumni Roster..."}
                  onChange={(selectedItem: Resident) =>
                    setTypeAheadResult(selectedItem)
                  }
                ></Autocomplete>
              </div>
              <div className="align-self-center ms-2">
                <i className="pc-font-size-largest la la-search"></i>
              </div>
            </div>
            <Link
              to={"/Alumni"}
              className="align-self-end mt-2"
            >
              {"Back to Roster"}
            </Link>
          </div>
        </div>
      </div>
      <ResidentTrainingDetails
        residentInfo={selectedResidentInfo}
        editResident={() => null}
        updateResident={() => null}
        onReturnedToProgram={onReturnedToProgram}
        updateMedicalEducation={(medicalEducation: MedicalEducation) => updateResidentMedicalEducation(medicalEducation)}
      />
      <div className="d-flex mt-2">
        <div className="d-flex justify-content-start w-50">
          {getPreviousResident() ? (
            <Link to={`/Alumni/${getPreviousResident().physicianId}`}>
              <i className="la la-angle-left ml-2"></i>
              {getPreviousResident().name.fullName}
            </Link>
          ) : (
            <span></span>
          )}
        </div>
        <div className="d-flex justify-content-end w-50">
          {getNextResident() ? (
            <Link to={`/Alumni/${getNextResident().physicianId}`}>
              {getNextResident().name.fullName}{" "}
              <i className="la la-angle-right mr-2"></i>
            </Link>
          ) : (
            <span></span>
          )}
        </div>
      </div>
    </>
  );
}